import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCrewHoliday, type CrewHoliday } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<CrewHoliday>
    useData={useCrewHoliday}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
